export const ActualRainfallConstants = {
  CommonLayers: [
    //   {
    //   layerNameType: 'FORECAST_WIDGETS_ADMIN',
    //   serviceType: 'WmsLayer',
    //   view: 'Admin',
    //   type: 'Base',
    //   env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    // },
    // {
    //   layerNameType: 'BLOCK',
    //   serviceType: 'WmsLayer',
    //   view: 'Admin',
    //   type: 'Base',
    //   name: 'blockLayer',
    //   env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //   minZoom: 9
    // },
    // {
    //   layerName: 'forecast:AP_VILLAGE',
    //   serviceType: 'WmsLayer',
    //   view: 'Admin',
    //   type: 'Base',
    //   name: 'villageLayer',
    //   env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //   minZoom: 12
    // },
    // {
    //   layerNameType: 'SUBBASIN',
    //   serviceType: 'VectorLayer',
    //   view: 'Basin',
    //   type: 'Base',
    //   interactive: true,
    //   env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //   locationName: 'sub_basin'
    // }
    // {
    //     layerNameType: 'STATE',
    //     serviceType: 'VectorLayer',
    //     view: 'Both',
    //     type: 'Time',
    //     env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //     // dataurl: 'heatWatches/getHeatWatchesData',
    //     hval: 'hwv',
    //     hcat: 'hwc'
    //   },
    {
      layerNameType: 'STATE',
      serviceType: 'WmsLayer',
      view: 'Both',
      type: 'Base',
      env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
      pane: 'state',
      styles: 'INDIA_STATE_NAMES',
      minZoom: 5,
    },
  ],

  HeatMapOptions: {
    type: 'Time',
    view: 'Admin',
    serviceType: 'HeatMap'
  },

  CroppedHeatMapOptions: {
    type: 'Time',
    view: 'Admin',
    serviceType: 'CroppedHeatMap'
  },

  GeoJsonOptions: {
    type: 'Time',
    view: 'Admin',
    serviceType: 'GeoJsonMarker',
    pane: 'state'
  },

  Legend: {
    LOW: {
      colorValues: [
        {
          backgroundColor: '#FFFFFF',
          color: '#000000',
          text: '0'
        },
        {
          backgroundColor: '#C3FDCA',
          color: '#000000',
          text: '0.1'
        },
        {
          backgroundColor: '#01FF04',
          color: '#000000',
          text: '2.5'
        },
        {
          backgroundColor: '#048500',
          color: '#FFFFFF',
          text: '15.6'
        },
        {
          backgroundColor: '#FDC0CB',
          color: '#FFFFFF',
          text: '64.5'
        },
        {
          backgroundColor: '#FC0300',
          color: '#FFFFFF',
          text: '115.6'
        },
        {
          backgroundColor: '#610301',
          color: '#FFFFFF',
          text: '>204.5'
        }
      ],
      Units: 'mm',
    },
    MED: {
      colorValues: [
        {
          backgroundColor: '#FFFFFF',
          color: '#000000',
          text: '0'
        },
        {
          backgroundColor: '#C3FDCA',
          color: '#000000',
          text: '0.1'
        },
        {
          backgroundColor: '#01FF04',
          color: '#000000',
          text: '2.5'
        },
        {
          backgroundColor: '#048500',
          color: '#FFFFFF',
          text: '15.6'
        },
        {
          backgroundColor: '#FDC0CB',
          color: '#FFFFFF',
          text: '64.5'
        },
        {
          backgroundColor: '#FC0300',
          color: '#FFFFFF',
          text: '115.6'
        },
        {
          backgroundColor: '#610301',
          color: '#FFFFFF',
          text: '>204.5'
        }
      ],
      Units: 'mm',
    },
    HIGH: {
      colorValues: [
        {
          backgroundColor: '#FFFFFF',
          color: '#000000',
          text: '0'
        },
        {
          backgroundColor: '#C3FDCA',
          color: '#000000',
          text: '0.1'
        },
        {
          backgroundColor: '#01FF04',
          color: '#000000',
          text: '2.5'
        },
        {
          backgroundColor: '#048500',
          color: '#FFFFFF',
          text: '15.6'
        },
        {
          backgroundColor: '#FDC0CB',
          color: '#FFFFFF',
          text: '64.5'
        },
        {
          backgroundColor: '#FC0300',
          color: '#FFFFFF',
          text: '115.6'
        },
        {
          backgroundColor: '#610301',
          color: '#FFFFFF',
          text: '>204.5'
        }
      ],
      Units: 'mm',
    },
    CURRENT_DATE: {
      colorValues: [
        {
          backgroundColor: '#FFFFFF',
          color: '#000000',
          text: '0-0.1'
        },
        {
          backgroundColor: '#C3FDCA',
          color: '#000000',
          text: '0.1-2.5'
        },
        {
          backgroundColor: '#01FF04',
          color: '#000000',
          text: '2.5-15.6'
        },
        {
          backgroundColor: '#048500',
          color: '#FFFFFF',
          text: '15.6-64.5'
        },
        {
          backgroundColor: '#FDC0CB',
          color: '#FFFFFF',
          text: '64.5-115.6'
        },
        {
          backgroundColor: '#FC0300',
          color: '#FFFFFF',
          text: '115.6-204.5'
        },
        {
          backgroundColor: '#610301',
          color: '#FFFFFF',
          text: '>204.5'
        }
      ],
      Units: 'Rainfall in mm',
    },
    PAST_DATE: {
      colorValues: [
        {
          backgroundColor: '#DEDEDD',
          color: '#000000',
          text: '0-0.25'
        },
        {
          backgroundColor: '#D1FCC4',
          color: '#000000',
          text: '0.25-25'
        },
        {
          backgroundColor: '#97E994',
          color: '#000000',
          text: '25-65'
        },
        {
          backgroundColor: '#2D9D31',
          color: '#FFFFFF',
          text: '65-125'
        },
        {
          backgroundColor: '#FDA3A5',
          color: '#FFFFFF',
          text: '125-250'
        },
        {
          backgroundColor: '#FEBF02',
          color: '#FFFFFF',
          text: '250-400'
        },
        {
          backgroundColor: '#9C34C7',
          color: '#FFFFFF',
          text: '400-600'
        },
        {
          backgroundColor: '#951828',
          color: '#FFFFFF',
          text: '600-1500'
        },
        {
          backgroundColor: '#AFA5FC',
          color: '#000000',
          text: '1500-2500'
        }
      ],
      Units: 'Rainfall in mm',
    },
  },
  legendData: {
    levels: [
      {
        color: '#ffffff',
        name: 'mm'
      },
      {
        color: '#DEDEDD',
        name: '0.0-0.1'
      },
      {
        color: '#D1FCC4',
        name: '0.2-2.5'
      },
      {
        color: '#97E994',
        name: '2.6-15.5'
      },
      {
        color: '#048500',
        name: '15.6-64.5'
      },
      {
        color: '#FDA3A5',
        name: '64.6-115.6'
      },
      {
        color: '#FEBF02',
        name: '115.7-204.5'
      },
      {
        color: '#6BC8D1',
        name: '204.6-250.1'
      },
      {
        color: '#AFA5FC',
        name: '250.2-300.1'
      },
      {
        color: '#9C34C7',
        name: '>300.1'
      }
    ]
  }
};
